<template>

	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fl">

					<usermenu></usermenu>
				</div>
				<div class="fr">
					<div class="user_center" v-if="menu_id == 1">

						<div class="user_de_ti">基本资料</div>


						<div class="edit_pass_word">

							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									用户ID
								</div>
								<div class="input">
									<span>XMYX001{{ userinfo.id }}</span>
								</div>

							</div>

							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									手机号
								</div>
								<div class="input">
									<span>{{ userinfo.mobile }}</span>
								</div>

							</div>

							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									昵称
								</div>
								<div class="input">
									<el-input v-model="userinfo.nickname" placeholder="请输入昵称"></el-input>
								</div>

							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									联系邮箱
								</div>
								<div class="input">
									<el-input v-model="userinfo.email" placeholder="请输入邮箱"></el-input>
								</div>
							</div>
							<!-- <div class="item t-flex t-flex-items-center">
								<div class="lable">
									联系地址
								</div>
								<div class="input">
									<el-input v-model="userinfo.address" placeholder="请确认新密码"></el-input>
								</div>
							</div> -->
							<div style="padding-top: 20px;">
								<div class="debtn" @click="editUser">提交修改</div>
							</div>

						</div>
					</div>





				</div>
			</div>
		</div>
	</div>

</template>

<script>
import usermenu from '@/components/dialogs/usermenu'
import {
	Notification,
	Message
} from 'element-ui'
import moment from 'moment';
export default {
	components: {
		usermenu

	},
	data() {
		return {
			list: [],
			content: "",
			active: 0,
			title: "",
			info: {},
			acc: "",
			pass: "",
			pass2: "",
			code: "",
			menu_id: 1,
			menu: [{
				id: 1,
				name: "基本资料",
				url: "/user"
			},

			{
				id: 7,
				name: "实名认证",
				url: "/shiming"
			},


			{
				id: 2,
				name: "我的收藏",
				url: "/shoucang"
			},
			{
				id: 6,
				name: "我的订单",
				url: "/order"
			},
			{
				id: 4,
				name: "修改密码",
				url: "/editpass"
			},
			{
				id: 5,
				name: "退出登录",
			}
			],
			page: 1,
			list: [],
			pagination: {
				total: 0,
				per_page: 0,
			},
			pass: "",
			pass1: "",
			pass2: ""

		}
	},
	computed: {
		userinfo() {
			return this.$store.getters.userinfo
		}
	},
	created: function (data) {

		// this.getDetail();


	},
	watch: {
		$route() {

		}
	},
	methods: {
		formatTimestamp(timestamp) {
			return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
		},

		open(item) {

			if (item.id == 5) {



				localStorage.removeItem('usertoken')
				sessionStorage.removeItem('usertoken')
				// localStorage.setItem('path', this.$route.path)
				this.$router.push("/")
			} else {

				this.$router.push(item.url)
			}
		},


		editUser() {
			var that = this
			this.rq.requests.post("api/game/user/profile", {
				nickname: that.userinfo.nickname,
				email: that.userinfo.email,
				// address: that.userinfo.address,

			}).then(res => {

				Message.success({
					message: "修改成功",
					duration: 3000
				})
				location.reload()
			}).catch(error => {

			})

		},





	}


}
</script>